//react...
import React from "react";

//styles...
import "./Header.styles.css";

//react-bootstrap...
import { Container, Nav, Navbar, NavbarBrand } from "react-bootstrap";
import Logo from "../Logo/Logo";
import { Link } from "react-router-dom";


const Header = () => {
  return (
    <Navbar collapseOnSelect sticky="top" bg="light" expand="lg">
      <Container>
        <Link to="/home" className="link">
          <NavbarBrand>
            <Logo /> Armco Trading
          </NavbarBrand>
        </Link>

        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse className="justify-content-end">
          <Nav>
            <Link className="link navLink" to={"/"}>
              Homepage
            </Link>
            <div className="vr break-point" />
            <Link className="link navLink" to={"/aftersalesservice"}>
              After Sales Service
            </Link>
            <div className="vr break-point" /> 
            <Link  className="link navLink" to='/products'>
              Products
            </Link>
            <div className="vr break-point" />
            <Link className="navLink link" to="/news">
              News{" "}
            </Link>
            <div className="vr break-point" />
            <Link className="navLink link" to="/about">
              About us
            </Link>
            <div className="vr break-point" />
            <Link className="navLink link" to="/contact">
              Contact us{" "}
            </Link>
            <div className="vr break-point" />
            <Link className="navLink link" to="/faq">
              FAQ{" "}
            </Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
